/**
 * In-app clipboard for tracker “Copy/Paste instrument” (sound slot, not pattern cells).
 */
import type { FxNode, Instrument, SlotMix } from "../../../../src/lib/audio";

export type InstrumentSlotPayload = {
  instrument: Instrument;
  slotMix: SlotMix;
  slotFx: FxNode[];
  slotBankId: string | undefined;
  wtSlotBankId: string | undefined;
  samplerSlotBankId: string | undefined;
};

let clipboard: InstrumentSlotPayload | null = null;

export function getInstrumentClipboard(): InstrumentSlotPayload | null {
  return clipboard;
}

export function setInstrumentClipboard(next: InstrumentSlotPayload | null): void {
  clipboard = next;
}

export function hasInstrumentClipboard(): boolean {
  return clipboard != null;
}

export function cloneInstrumentSlotPayload(payload: InstrumentSlotPayload): InstrumentSlotPayload {
  return {
    instrument: structuredClone(payload.instrument),
    slotMix: structuredClone(payload.slotMix),
    slotFx: structuredClone(payload.slotFx),
    slotBankId: payload.slotBankId,
    wtSlotBankId: payload.wtSlotBankId,
    samplerSlotBankId: payload.samplerSlotBankId,
  };
}
